(function () {
  function initialize(section) {
    if (!section || section.dataset.alFaqInitialized === 'true') return;
    section.dataset.alFaqInitialized = 'true';
    section.querySelectorAll('.al-acc__q').forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = btn.parentElement;
        var ans  = item.querySelector('.al-acc__a');
        var open = item.classList.contains('open');
        section.querySelectorAll('.al-acc__item').forEach(function(i){
          i.classList.remove('open');
          i.querySelector('.al-acc__q').setAttribute('aria-expanded','false');
          i.querySelector('.al-acc__a').style.maxHeight = null;
        });
        if (!open) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded','true');
          ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    });

    var revEls = section.querySelectorAll('.al-reveal');
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){ e.target.classList.add('al-visible'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      revEls.forEach(function(el){ obs.observe(el); });
    } else {
      revEls.forEach(function(el){ el.classList.add('al-visible'); });
    }

  }

  function initializeAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('.al-faq')) initialize(context);
    if (!context.querySelectorAll) return;
    Array.prototype.forEach.call(context.querySelectorAll('.al-faq'), initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
